<div class="all-filters-wrapper">
    <finder-filter-pills
        class="filter-pills"
        [pills]="appliedFacets"
        [clearLabel]="data?.labels.clearAll"
        [pillAriaLabel]="data?.labels.pillAriaLabel"
        [pillsWrapperLabel]="data?.labels.pillsWrapper"
        (clear)="clearPills()"
        (pillClose)="closePill($event)">
    </finder-filter-pills>
    <finder-height-slider
        class="height-slider"
        *ngIf="data?.useHeightFilter"
        showCheckbox="true"
        [heightLabel]="data?.labels.height">
    </finder-height-slider>
    <div class="all-filters">
        <div class="filter-group"
            *ngFor="let filter of allFilters"
            [ngStyle]="filter.style">
                <div class="group-label">
                    <span class="label">{{filter.label}}</span>
                    <span class="tool-tip-label" *ngIf="filter.toolTipText">
                        {{filter.toolTipText}}
                    </span>
                </div>
                <div class="facet-groups" *ngFor="let facetGroup of filter.facetGroups">
                    <div *ngIf="facetGroup.label" class="label">{{facetGroup.label}}</div>
                    @defer {
                        <finder-ra-checkbox
                            class="checkbox"
                            *ngFor="let facet of facetGroup.facets"
                            alignment="top"
                            [checked]="facet.value"
                            (checkedChanged)="onCheck($event, facet)">
                            {{facet.label}}
                            <div class="description" *ngIf="facet.description">
                                {{facet.description}}
                            </div>
                        </finder-ra-checkbox>
                    }
                </div>
        </div>
    </div>
    <finder-button theme="primary" (click)="dismiss()">{{ data?.labels.done }}</finder-button>
</div>
